import React, { Component, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, convertObjectToArray, formatNumber, importCSS, getRemotedbUrl, isNotEmpty, getStageName } from '../../lib/ep.js';
import { HashRouter as Router, Route } from 'react-router-dom';
import { size as _size } from 'lodash';
import { stage_categories, stage_promotion_types, stage_types, with_score } from '../../data/bootstrap_stages';

import ActionLink from '../builder/ActionLink';
import { SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ConfirmButton, { DeleteButton } from '../builder/ConfirmButton.js';
import CopyLink from '../builder/CopyLink.js';
import NavigationTabs from '../builder/NavigationTabs';
import Spinner from '../builder/Spinner';
import Tooltip from '../builder/Tooltip';
import ParticipateFormEdit from './ParticipateFormEdit';

import UserAvatar from '../front/UserAvatar';
import UserParticipationsMultistageListBuilder from '../front/layers/UserParticipationsMultistageListBuilder';

import SegmentBuilder, { SegmentRibbons } from './elements/SegmentBuilder.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import SaveButton from '../builder/SaveButton.js';
import SectionTitle from '../builder/SectionTitle.js';
import PunchCardStandalone from '../front/PunchCardStandalone.js';
import { formatTokenTitle } from '../front/loyalty/TokenAmount.js';
import Model from '../builder/Model.js';
import Input from '../builder/Input.js';
import Select from '../builder/Select.js';
import FieldLabel from '../builder/FieldLabel.js';
import { SendClaimActions, StatusClaim } from '../../containers/PrizeFulfillment.js';
import RibbonCollection from '../ui_items/RibbonCollection.js';
import { useAccount } from '../context/accountContext.js';

const ResumeeWrapper = ({ actual_section, sections, ...props }) => {
	return (
		<div class="tabbed_registered_section">
			<NavigationTabs
				active={actual_section}
				sections={sections}
				display_type='tab'
			/>

			{(props?.pre_contents ?? false) && (
				props.pre_contents
			)}

			<div class="tab_contents">
				{props.children}
			</div>
		</div>
	)
};

const VirtualCoinsResumee = ({ promotion, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const { MyAccount } = useAccount();

	const default_model = { amount:1, multiplier:'more', reason:"" };

	const [ display, setDisplay ] = useState('data');	// 'data' | 'manage' | 'success' (on manage)
	const [ model, setModel ] = useState(default_model);

	const is_multistage = promotion?.is_multistage ?? false;

	const tokens = props?.tokens ?? false;

	const change = (k, v) => {
		if(k == 'amount') v = Math.abs(parseInt(v));
		setModel({ ...model, [k]:v });
	};

	const applyTokens = (cb) => {
		const data = {
			login_id:props.login_id,
			token_id:Object.keys(props.tokens)[0],
			amount:(model.multiplier == 'more') ? model.amount : -model.amount,
			reason:model.reason,
		};

		$.post(`/users/tokens/${promotion.id}`, data, (res) => {
			cb();

			if(props.onManuallyUpdate != undefined) props.onManuallyUpdate((props?.actual_tokens ?? 0) + parseInt(data.amount));

			if(res.status != '1') return;
			setDisplay('success');
		}, 'JSON');
	};

	if(tokens === false) {
		return (
			<ResumeeWrapper
				{...props.navigation_props}
			>{i18n("Unexpected error")}</ResumeeWrapper>
		)
	}

	let transactions = Object.values(props?.transactions ?? {})[0];
	if(transactions == undefined) transactions = [];

	return (
		<ResumeeWrapper
			{...props.navigation_props}
		>
			{(display == 'data') && (
				<>
					{(transactions.length > 0) ? (
						<div class="gui_participations_list is_builder">
							<ActionLink
								onClick={() => {
									setModel(default_model);
									setDisplay('manage');
								}}
								_class={{ other:'not_in_bottom' }}
							>Manage the user's virtual coins</ActionLink>
	
							<table class="single_user_participations" cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
								<thead>
									<tr>
										<th style={{width:'8%'}} />

										<th class="gui_text_align_start">{i18n("Description")}</th>

										<th class="gui_text_align_start" style={{width:'22%'}}>{i18n("Date")}</th>
									</tr>
								</thead>

								<tbody>
									{transactions.map((_item, p) => {
										const item = _item.LoyaltyLogin;
										const token = props.tokens[item.token_id].LoyaltyToken;

										const data = JSON.parse(item?.data ?? '{}');
										data.num = parseInt(item.amount);
										data.coin_name = formatTokenTitle(token, data.num);

										let icon = false;
										let message = '';
										let extra_message = '';
										switch(item.type) {
											case '1':
												// on token receive after participate:
												// target : stage_id
												data.stage_name = getStageName({ display_title:data?.stage_name, id:item.target }, i18n);
												icon = 'knk-plus';
												message = (is_multistage) ? "You've earned {num} {coin_name} by participating in: {stage_name}." : "You've earned {num} {coin_name}.";
												break;

											case '2':
												// on prize redeem:
												// target : prize_type_id
												data.prize_name = data.prize_name;
												data.num = Math.abs(data.num);
												message = "You've spent {num} {coin_name} to redeem the prize: {prize_name}.";
												icon = 'knk-present-fill';
												break;

											case '3':
												// on manual modification (from Audience):
												// target : agent_id
												if(data.num < 0) {
													message = "You've spent {num} {coin_name}{reason}.";
												} else {
													message = "You've earned {num} {coin_name}{reason}.";
												}
												extra_message = item.reason;
												data.reason = "";	// we use the label containing "{reason}" but only to avoid createing a new label almost exact
												data.num = Math.abs(data.num);
												icon = 'knk-me';
												break;

											case '4':
												// on winning a prize with coins:
												// target : prize_type_id
												data.prize_name = data.prize_name;
												message = "You've earned {num} {coin_name} after winning the prize: {prize_name}.";
												icon = 'knk-plus';
												break;

											case '5':
												// on paying a requirement in coins:
												// target : stage_id
												data.stage_name = getStageName({ display_title:data?.stage_name, id:item.target }, i18n);
												data.prize_name = data.prize_name;
												data.num = Math.abs(data.num);
												message = (is_multistage) ? "You've spent {num} {coin_name} by participating in: {stage_name}." : "You've spent {num} {coin_name}.";
												icon = 'knk-recommendator';
												break;

											case '6':
												// via API:
												if(data.num < 0) {
													message = "You've spent {num} {coin_name}{reason}.";
												} else {
													message = "You've earned {num} {coin_name}{reason}.";
												}
												data.reason = isNotEmpty(token, 'reason') ? `: ${token.reason}` : "";
												data.num = Math.abs(data.num);
												icon = 'knk-me';
												break;
										}

										let final_msg = props.intl.formatMessage({ id:message }, data);
										if(extra_message != '' && extra_message != false) {
											final_msg += `<br /><strong>${i18n("Reason")}:</strong> ${extra_message}`;
										}

										return (
											<tr key={'p' + p}>
												<td class="ranking_pos">#{(`${transactions.length - p}`).padStart(2, '0')}</td>

												<td class="gui_text_align_start">
													<div class="sided_contents">
														<span class={icon} />

														<div class="title">
															<span
																class="__gui_cutTextOnOverflow"
																dangerouslySetInnerHTML={{ __html:final_msg }}
															/>
														</div>
													</div>
												</td>
												<td class="gui_text_align_start">{EPGetTimezone(item.created, promotion.timezone, MyAccount.getAgentDateTimeFormat())}</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					) : (
						<div class="gui_participations_list is_builder">
							<div>{i18n("There are no results.")}</div>
						</div>
					)}
				</>
			)}

			{(display == 'manage') && (
				<div class="gui_participations_list is_builder">
					<ActionLink
						onClick={() => setDisplay('data')}
						_class={{ other:'not_in_bottom' }}
					>View history</ActionLink>

					<p>{i18n("Add/Remove virtual coins manually to this user.")}</p>

					<Model
						classname='gui_flexbox_auto gui_flex_align_center gui_not_in_top'
						model={model}
						change={change}
						style={{ gap:'0.5em', width:'100%' }}
					>
						<FieldLabel
							style={{ flex:'0 0 calc(30% - 0.5em)' }}
						>Number of coins</FieldLabel>

						<Select
							name="multiplier"
							values={[
								{ k:'more', v:i18n("Add virtual coins") },
								{ k:'less', v:i18n("Remove virtual coins") },
							]}
							_class={{ first:true }}
						/>

						<Input
							name="amount"
							_type='number'
							_class={{ first:true }}
							_field_style={{ flexGrow:'1' }}
						/>
					</Model>

					<Input
						name="reason"
						_class={{ size:70 }}
						model={model}
						change={change}
					>Reason</Input>

					<ButtonCollection
						_class={{ other:'not_in_top gui_flex_end'}}
					>
						<SecondaryButton
							onClick={() => setDisplay('data')}
						>Cancel</SecondaryButton>

						<SaveButton
							type='confirm'
							_position='top'
							onClick={(e, cb) => applyTokens(cb)}
						>Apply</SaveButton>
					</ButtonCollection>
				</div>
			)}

			{(display == 'success') && (
				<div class="gui_participations_list is_builder">
					<ActionLink
						onClick={() => setDisplay('data')}
						_class={{ other:'not_in_bottom' }}
					>View history</ActionLink>
					
					<p class="knk-on greenIcon">{i18n("The user's virtual coins have been updated successfully.")}</p>

					<ButtonCollection
						_class={{ other:'not_in_top gui_flex_end'}}
					>
						<SecondaryButton
							onClick={() => setDisplay('data')}
						>Go back</SecondaryButton>
					</ButtonCollection>
				</div>
			)}
		</ResumeeWrapper>
	)
};

class SingleRegisteredEntry extends Component {
	constructor(props, context) {
		super(props, context);
		
		this.skip_actions = (props.skip_actions != undefined) ? props.skip_actions : false;
		this.promotion = (props.promotion != undefined) ? props.promotion : false;
		this.questions = (props.questions != undefined) ? props.questions : [];
		this.prize_types = (props.prize_types != undefined) ? convertObjectToArray(props.prize_types) : [];
		this.user_data = (props.user_data != undefined) ? props.user_data : [];
		this.register = (this.user_data.register != undefined) ? this.user_data.register : [];
		this.participations = (this.user_data.participations != undefined) ? this.user_data.participations : [];
		this.prizes = (this.user_data.prizes != undefined) ? (this.user_data.prizes).reverse() : [];
		this.stages = (props.stages != undefined) ? Object.values(props.stages) : {};
		
		this.stage_participations = { summary:[], total:0 };
		
		this.has_quiz_stages = false;
		this.has_game_stages = false;
		this.has_team_stages = false;
		this.has_voting_stages = false;

		this.has_avatar = this.register.User?.avatar ?? false;

		this.state = {
			segments:this.user_data?.segments ?? [],
			all_segments:this.props?.segments ?? [],
			tmp_segments:[],
			loading:true,
			avatar_blocked:(this.has_avatar !== false && this.has_avatar.indexOf('blocked') > -1) ? true : false,
			forced_avatar:this.has_avatar,
			edit_user:null,
			all_participations:{ summary:[], total:0 },
			display_layer_segments:false,
			display_punch_card:false,
			total_loyalty_tokens:(props.loyalty != undefined) ? Object.values(props.loyalty.totals)[0] : 0,
		}
	}

	componentWillMount() {
		importCSS('comp/audience.css');
		importCSS('comp/owner_multigallery.css');

		var order_stages = {};
		var i = 1;

		this.participations.map((part, p) => {
			const this_stage = this.stages.filter((obj) => { return (obj.Stage.id == part.User.stage) ? true : false; })[0];

			if(this_stage != undefined) {
				if(order_stages[this_stage.Stage.id] == undefined) {
					order_stages[this_stage.Stage.id] = i;
					i++;
				}

				const is_game = this_stage.Stage?.is_game ?? false;
				if(is_game && !this.has_game_stages) this.has_game_stages = true;

				const is_quiz = this_stage.Stage?.is_quiz ?? false;
				if(is_quiz && !this.has_quiz_stages) this.has_quiz_stages = true;

				const is_team = this_stage.Stage?.is_team ?? false;
				if(is_team && !this.has_team_stages) this.has_team_stages = true;

				const is_voting = this_stage.Stage?.is_voting ?? false;
				const is_media = this_stage.Stage?.is_media ?? false;
				if(is_voting && !this.has_voting_stages) this.has_voting_stages = true;

				const is_dynamic_qr_req = (this_stage.Stage.reqs_type == 5 && this_stage.Stage.reqs_qr_type == 'dynamic') ? true : false;

				let stage_icon = '';
				let stage_type_name = "";
				const stage_type = stage_types.filter(f => (f.id == this_stage.Stage.promotion_type_id) ? true : false)[0];
				if(stage_type != undefined) {
					stage_icon = stage_type.icon_class;
					stage_type_name = stage_type.name;
				}

				var _p = {
					Stage:{
						display_title:this_stage.Stage.display_title,
						is_game:is_game,
						is_media:is_media,
						is_quiz:is_quiz,
						is_voting:is_voting,
						is_team:is_team,
						order:order_stages[this_stage.Stage.id],
						icon:stage_icon,
						stage_type:stage_type_name,
						is_dynamic_qr_req:is_dynamic_qr_req,
					},
					StageScore:{
						id:part.User.id,
						created:part.User.created,
						code:part.User.code ? part.User.code : false,
						data:this.register.User.first_name + " " + this.register.User.last_name,
						ip:part.User.ip,
						login_id:part.User.login_id,
						quiz_entry:part.User.quiz_entry,
						score:part.User.quiz_result,
						has_prize:part.User.has_prize,
						has_ticket:part.User.has_ticket,
						stage_id:part.User.stage,
						browser:part.User.browser,
						browser_label:part.User.browser_label,
						device:part.User.device,
						time:part.User.time,
						device_label:part.User.device_label,
						public_entry:part.User.public_entry,
					}
				};

				if(this_stage.Stage.teams != undefined) _p.Stage.teams = this_stage.Stage.teams;

				if(part.CustomValue != undefined && part.CustomValue.length > 0) {
					var cfs = [];
					part.CustomValue.map((cv, i) => {
						var cf = this.promotion.CustomField.filter((obj) => { return obj.id == cv.custom_field_id })[0];
						if(cf != undefined) {
							cfs.push({
								config:cf.config,
								stage_id:cv.stage,
								title:(cf.short_title != undefined) ? cf.short_title : cf.title,
								type:cf.type,
								value:cv.value,
							});
						}
					});
					if(cfs.length > 0) _p.StageParticipation = cfs;
				}

				this.state.all_participations.summary.push(_p);
			}
		});

		$.get(getRemotedbUrl(`/users/entry_summary_builder/${this.promotion.Promotion.id}/?id=${this.props.login_id}`), (res) => {
			res.summary.map((part, p) => {
				const this_stage = this.stages.filter((obj) => { return (obj.Stage.id == part.StageScore.stage_id) ? true : false; })[0];

				let stage_icon = '';
				let stage_type_name = "";
				const stage_type = this_stage && stage_types.filter(f =>{ return (f.id == this_stage.Stage.promotion_type_id) ? true : false})[0];
				if(stage_type != undefined) {
					stage_icon = stage_type.icon_class;
					stage_type_name = stage_type.name;
				}

				if(res.summary[p].Stage != undefined) {
					res.summary[p].Stage.icon = stage_icon;
					res.summary[p].Stage.stage_type = stage_type_name;
				}
				
				if(part.Participations != undefined){
					part.Participations.map((item,i)=>{
						const summary = this.state.all_participations.summary.find(summary=>(summary.StageScore.id == item['User']['id']));
						if (summary) {
							summary.Participation = item['User'];	
						}
						//this.state.all_participations.summary[i].Participation = item['User'];
					})
				}

			});
			this.stage_participations = res;
			this.state.all_participations.total = res.total;
			this.state.loading = false;
			this.setState({...this.state});
		}, 'JSON');
	}

	updateLoyaltyTokens(new_val) {
		this.setState({ total_loyalty_tokens:new_val });
	}

	get_status_class(status) {
		var _class = '';
		switch(status) {
			case '0':
				_class = 'entry_unpublished blueBg';
				break;
			case '1':
				_class = 'entry_published greenBg';
				break;
			case '2':
			case '3':
				_class = 'entry_processing orangeBg';
				break;
			case '4':
				_class = 'entry_rejected redBg';
				break;
			case '5':
				_class = 'knk-reject-user entry_blocked blackBg whiteColor';
				break;
		}
		return _class;
	}

	actions = (data, cb) => {
		switch(data.type) {
			case 'edit_user':
				this.props.userAction(data.type, [data.id], data.form, cb);
				this.register.User = Object.assign({...this.register.User}, {...data.form});
				if(data.form.nickname != undefined)this.register.User.name = data.form.nickname;
				this.setState({...this.state});
				break;
			case 'delete_participation':
				this.deleteParticipation(data.id);
				if (this.props.actions != undefined) this.props.actions(data);
				break;
			case 'star':
			case 'unstar':
				this.props.userAction(data.type,data.id);
				const marked = this.register.User.extra != undefined && this.register.User.extra.marked != undefined ? this.register.User.extra.marked : 0;
				this.register.User.extra.marked = (data.type == 'star') ? true : false;
				this.setState({...this.state});
				break;
			case 'block':
			case 'unblock':
				this.props.userAction(data.type,data.id);
				const blocked = this.register.User.public_entry == '5' ? true : false;
				this.register.User.public_entry = (data.type == 'block') ? '5' : '1';
				this.setState({...this.state});
				break;
			case 'email':
				$.post(getRemotedbUrl(`/emails/emailManualFromRegistered/${this.promotion.Promotion.id}`), { ids:JSON.stringify([data.id]), filter_by_email:true }, (result) => {
					if(result.status) window.location = result.url_redirect;
				}, 'json');
				if(cb != undefined) cb();
				return;

			case 'avatar':
				this.setState({
					avatar_blocked:!this.state.avatar_blocked,
					forced_avatar:(this.state.avatar_blocked) ? false : 'blocked',
				});
				this.props.userAction(data.type, data.id);
				break;

			case 'update_segments':
				
				this.props.userAction(data.type,[this.register.User.login_id],{segments:this.state.tmp_segments});
				break;
		}
	}

	deletePrize = (prize_id) => {
		$.post(`/prizes/unredeem/${this.promotion.Promotion.id}`,{prize_id},'JSON');
		this.onDeletePrize(prize_id);
	}	

	editUser = (user) => {
		const promotion = (this.props.promotion != undefined && this.props.promotion.Promotion != undefined) ? this.props.promotion.Promotion : {};
		if(promotion.need_nickname == "1")user.nickname = user.name;
		this.setState({edit_user:user});
	}

	onEditUser = (user, cb) => {
		this.actions({
			type:'edit_user',
			id:this.register.User.id,
			form:user,
		}, () => {
			this.setState({ edit_user:null });
			if(cb != undefined) cb();
		});
	}

	onDeleteParticipation = (participation_id) => {
		this.state.all_participations.summary = this.state.all_participations.summary.filter(st => st.StageScore.id != participation_id);
		this.setState({...this.state});
	}

	onDeletePrize = (prize_id) => {
		this.prizes = this.prizes.filter(prize=>prize.Prize.id != prize_id);
		this.setState({...this.state});
	}


	deleteParticipation = (participation_id) => {
		$.post(`/users/delete/${participation_id}/${this.promotion.Promotion.id}`);
		this.onDeleteParticipation(participation_id);
	}
	

	deleteSegment = (i) => {
		this.setState({ segments:this.user_data.segments.filter((seg) => seg != i)});
		if (this.props.segmentDeleted != undefined) this.props.segmentDeleted([this.user_data.register.User.id],i);
	}

	toogleLayerSegments = () => {
		this.state.display_layer_segments = !this.state.display_layer_segments;
		if(this.state.display_layer_segments){
			this.state.tmp_segments = [...this.state.segments];
		}
		this.setState({...this.state});
	}

	segmentSelected = (segment_id)=>{
		const _segments = this.state.tmp_segments;
		this.setState({ tmp_segments:_segments.includes(segment_id) ? _segments.filter(s=>s!=segment_id) : [..._segments,segment_id]});
	}

	segmentCreated = (segment)=>{
		this.setState({ all_segments:[...this.state.all_segments,segment]});
		if(this.props.segmentCreated)this.props.segmentCreated(segment);
	}

	confirmSegments = (segment)=>{
		this.setState({segments:[...this.state.tmp_segments],display_layer_segments:false});
		this.actions({type:'update_segments' });
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const has_login = (this.props.login_id > 0) ? true : false;
		const basename = this.props?.basename ?? ""; 
		const owner = this.props?.useOwner ?? null; 
		const actual_plan = owner?.plan ?? null;
		const stages = this.props?.stages ?? [];
		const participations = this.state?.all_participations?.summary?? [];
		const stage_participations = stages.filter(stage => participations.map(p => String(p.Participation?.stage)).includes(String(stage.Stage.id)));

		const stamp_cards_stages = stage_participations.filter((s)=> {return s.Stage.type == stage_categories.ID_STAMPSCARD_CATEGORY.id});
		const score_stages = stage_participations.filter((s)=> { return with_score(s.Stage.promotion_type_id) == true}).length > 0 ? true : false;
		const has_loyalty = this.promotion?.Promotion?.loyalty_enabled ?? false;

		let tabs = [];
		const multiparticipation = this.promotion?.Promotion?.multi_participation ?? false;

		if(!this.skip_actions){
			if(has_login && multiparticipation) {
				tabs.push({
					label:`${i18n("Participations")} [${this.props?.user_data?.register?.User?.invitations ?? _size(this.state.all_participations.summary)}]`,
					link:`${basename}`,
					icon:'knk-profile',
				});
			}

			tabs.push({
				label:`${i18n("Score")} [${formatNumber(this.stage_participations.total)} ${i18n("points")}]`,
				link:`${basename}scores`,
				icon:'knk-goal',
				enabled:multiparticipation && score_stages
			})

			tabs.push({
				label:`${i18n("Prizes")} [${_size(this.prizes)}]`,
				link:`${basename}prizes`,
				icon:'knk-winners',
				enabled:(this?.prize_types ?? []).length > 0
			});

			tabs.push({
				label:`${i18n("Virtual coins")} [${this.state?.total_loyalty_tokens ?? 0}]`,
				link:`${basename}loyalty`,
				icon:'knk-money',
				enabled:has_loyalty
			});

			if(stamp_cards_stages.length > 0) {
				tabs.push({ 
					label:`${i18n("Stamp cards")}`,
					link:`${basename}stampcards`,
					icon:'knk-punch-card',
				});
			}
		}

		const tab_information = ({
			label:i18n("More information"),
			link:`${basename}other`,
			icon:'knk-user',
		});

		(multiparticipation) ? tabs.push(tab_information) : tabs.unshift(tab_information);

		let username = this.register.User.first_name + " " + this.register.User.last_name;
		let has_full_name = false;
		if(this.register.User.name != "" && this.register.User.name != username) {
			username = this.register.User.name;
			has_full_name = true;
		}

		const tz = this.promotion.Promotion.timezone;
		const tzcreated = moment.tz(this.register.User.created, "Europe/Madrid").tz(tz);

		const fbuid = this.register.User?.fbuid ?? false;

		const net_type = this.register.User.net_type;
		let login_network = false;
		let is_admin_participation = false;
		switch(net_type) {
			case '1':
				login_network = i18n("Facebook");
				break;

			case '2':
				login_network = i18n("Google");
				break;

			case '5':
				login_network = i18n("LinkedIn");
				break;

			case '12':
				is_admin_participation = true;
				break;
		}

		const marked = this.register.User?.extra?.marked ?? 0;
		const is_marked = (marked > 0) ? true : false;
		
		let external_id = false;
		let external_id_displayed = false;
		let external_id_copy = null;

		if(fbuid != false && fbuid != "0" && fbuid != "" && (net_type == '4' || net_type == '9')) {// || net_type == '11' 
			external_id = this.register.User?.extra?.external_id ?? fbuid;

			if(external_id.length > 20) {
				external_id_displayed = `${external_id.substring(0, 20)}...`;
				external_id_copy = <> [<CopyLink copy_link={external_id}>Copy</CopyLink>]</>;
			} else {
				external_id_displayed = external_id;
			}
		}

		const is_blocked = (this.register.User.public_entry == '5') ? true : false;
		const is_accepted = (this.register.User.public_entry == '1') ? true : false;
		const is_visitor = (this.register.User.net_type == '7') ? true : false;
		const skip_manual_prize = this.props?.skip_manual_prize ?? false;

		const status_user = (is_blocked) ? i18n("Blocked") : i18n("Accepted");

		let has_wl = this.promotion.Promotion.promo_type > 1 ? true : false;
		if(actual_plan){
			has_wl = actual_plan.plan_type >= 5;
		}
		const display_assign_segments = this.props.segments != undefined && has_wl;
		const user_segments = [...this.state.segments];
		if(display_assign_segments){	
			user_segments.push({
				title:"Assign segment", 
				color:'gray', 
				is_light:false, 
				icon:"knk-plus", 
				onClick:()=>this.toogleLayerSegments(),
			});
		}

		const not_assigned_segments = (this.state.all_segments).filter((s) => !((this.state.tmp_segments).includes(s.Segment.id)));

		return (
			<div>
				<aside class="registered_single_entry_info">
					<div class="user_info">
						<div>
							<UserAvatar
								is_builder={true}
								user={{ ...this.register.User, avatar:this.state.forced_avatar }}
								width={6}
								height={6}
								display_network_icon={true}
							/>

							{(this.state.forced_avatar !== false && !this.skip_actions) && (
								<ActionLink
									onClick={() => this.actions({type:'avatar', id:this.register.User.login_id })}
								>{(!this.state.avatar_blocked) ? "Block avatar" : "Re-enable"}</ActionLink>
							)}
						</div>

						<div class="data">
							<div class={`is_editable ${(this.skip_actions ? 'gui_remove_pointer_events' :'')}`} onClick={() => !this.skip_actions ? this.editUser(this.register.User) : null}>
								<h1 class="main_title editable_content gui_cutTextOnOverflow">{username}</h1>

								{(!this.skip_actions) && (
									<SquaredButton
										icon='knk-edit'
										_class={{other:'edit_this'}}
										aria-label="Edit"
									/>
								)}
							</div>

							{(this.register.User.email) && (
								<div class="gui_flexbox gui_flex_row gui_flex_nowrap gui_flex_start gui_flex_align_center gui_flex_space_between">
									<strong>{this.register.User.email}</strong>
								</div>
							)}

							<p>{i18n("***Registered on")}: {`${tzcreated.format('lll')}`}</p>

							<p>
								{i18n("ID")}: {(this.register.User.login_id)}

								{(external_id) && (
									<span class="gui_not_in_start_tiny">| {i18n((net_type == '4'/* || net_type=='11'*/) ? "External ID" : "Login code")}: {external_id_displayed}{external_id_copy}</span>
								)}
							</p>

							{(login_network !== false) && (
								<p>
									<span>{i18n("Login network")}: {login_network}</span>
								</p>
							)}

							{(!this.skip_actions) && (
								<SegmentRibbons
									segments={user_segments}
									all_segments={this.state.all_segments}
									onDelete={this.deleteSegment.bind(this)}
									_class={{other:'gui_not_in_top_tiny'}}
									promotion_id={this.register.User.promotion_id}
									login_id={this.register.User.login_id}
								/>
							)}

							{(this.state.display_layer_segments) && (
								<FloatingLayer _class={{ size:'small' }} backButton={() => this.toogleLayerSegments()}>
									<div>
										<SectionTitle>{this.props.intl.formatMessage({ id:"Assign segment to {name}" }, { name:username })}</SectionTitle>
										<SegmentBuilder
											segmentSelected = {this.segmentSelected.bind(this)}
											segmentCreated = {this.segmentCreated.bind(this)}
											selected = {this.state.tmp_segments}
											all_segments = {not_assigned_segments}
											promotion_id={this.promotion.Promotion.id}
											brand_id={window.owner_main_vars.organizer_id}
										/>
										<ButtonCollection in_floating={true}>
											<SaveButton
												onClick={() => this.confirmSegments()}
											>Save</SaveButton>

											<SecondaryButton
												onClick={() => this.toogleLayerSegments()}
											>Close</SecondaryButton>
										</ButtonCollection>
									</div>
									
								</FloatingLayer>
							)}
						</div>
					</div>

					<div class="basic_info">
						<ul>
							{(this.register.User.language != undefined && this.register.User.language != "") && (
								<li class="language_info">
									<span>{this.register.User.language}<Tooltip with_icon={false} position="top">Language</Tooltip></span>
								</li>
							)}

							{(this.register.User.country_flag != undefined && this.register.User.country_flag != '') && (
								<li class="country_info">
									<span><img src={this.register.User.country_flag} height="28" /><Tooltip with_icon={false} position="top" autotranslate={false}>{i18n("Connection country") + ": " + this.register.User.country_name}</Tooltip></span>
								</li>
							)}

							<li class={this.get_status_class(this.register.User.public_entry)}>
								<span>{status_user}<Tooltip with_icon={false} position="top">User status</Tooltip></span>
							</li>
						</ul>

						<div class="reject_confirmation">
							{((!is_admin_participation && (is_blocked || is_accepted) && !is_visitor)  && !this.skip_actions) && (
								<ConfirmButton
									onClick={() => this.actions({type:((is_blocked) ? 'unblock' : 'block'), id:this.register.User.id })}
									type='link'
								>{(is_blocked) ? "Unblock user" : "Block user"}</ConfirmButton>
							)}

							{(!is_admin_participation && !this.skip_actions) && (
								<ActionLink
									squared={true}
									active={is_marked}
									icon={false}
									_class={{ other:'small_squared_button' }}
									onClick={() => this.actions({type:((is_marked) ? 'unstar' : 'star'), id:this.register.User.id })}
								>{(is_marked) ? "Unmark as favorite" : "Mark as favorite"}</ActionLink>
							)}

							{(this.register.User.email && !this.skip_actions) && (
								<ActionLink
									onClick={() => this.actions({type:'email', id:this.register.User.id })}
								>Send email to this user</ActionLink>
							)}

							{(is_accepted && !skip_manual_prize) && (
								<ActionLink
									onClick={() => this.props.setBulkModalAction(true, 'manual_prize')}
								>Assign a manual prize</ActionLink>
							)}
						</div>
					</div>

					{(this.state.edit_user) && (
						<ParticipateFormEdit
							promotion={this.promotion}
							stage={this.stages.filter((s) => { return s.Stage.promotion_type_id == stage_promotion_types.MEDIA_AUTOCONTENT.id})[0]}
							intl={this.props.intl}
							user={this.register}
							onSubmit={(user, cb) => this.onEditUser(user, cb)}
							backButton={() => this.setState({ edit_user:null })}
						/>
					)}
				</aside>

				<Router hashType="noslash" basename={basename}>
					<div>
						<Route exact={true} path={/^\/(alerts|ips\/users|domains\/users)?$/i} render={(route) => {
							if(!multiparticipation && route.location.pathname == '/' || this.skip_actions)window.location.hash = 'other';

							return (
								<div class="tabbed_registered_section">
									<NavigationTabs
										active={route.location.pathname}
										sections={tabs}
										display_type='tab'
									/>
									
									{(!this.state.loading) ? (
										<div class="tab_contents">
											{(_size(this.state.all_participations.summary) > 0) ? (
												<UserParticipationsMultistageListBuilder
													stage_participations={this.state.all_participations}
													promotion={this.promotion.Promotion}
													stages={this.stages}
													display_date={true}
													has_game_stages={this.has_game_stages}
													has_quiz_stages={this.has_quiz_stages}
													has_voting_stages={this.has_voting_stages}
													has_team_stages={this.has_team_stages}
													is_builder={true}
													display_complete_info={true}
													display_total={false}
													display_prizes={true}
													username={username}
													on_delete_participation={this.onDeleteParticipation}
													validation_tags={this.props.validation_tags}	// only for OCR Ticket
													img_basedir={this.props.img_basedir}			// only for OCR Ticket
													actions={this.actions}
												/>
											) : (
												<div class="gui_participations_list is_builder">
													<div>{i18n("There are no results.")}</div>
												</div>
											)}
										</div>
									) : (
										<div class="tab_contents">
											<div class="gui_pos_rel" style={{minHeight:'20dvh'}}>
												<Spinner _class={{other:'is_transparent'}} force_bg={true}>Loading</Spinner>
											</div>
										</div>
									)}
								</div>
							)
						}} />

						<Route exact={true} path={'/scores'} render={(route) => {
							return (
								<div class="tabbed_registered_section">
									<NavigationTabs
										active={route.location.pathname}
										sections={tabs}
										display_type='tab'
									/>

									{(!this.state.loading) ? (
										<div class="tab_contents">
											{(_size(this.stage_participations.summary) > 0) ? (
												<UserParticipationsMultistageListBuilder
													stage_participations={this.stage_participations}
													type='grouped_by_stage'
													promotion={this.promotion.Promotion}
													display_date={true}
													has_game_stages={this.has_game_stages}
													has_quiz_stages={this.has_quiz_stages}
													has_voting_stages={this.has_voting_stages}
													is_builder={true}
													display_complete_info={true}
													display_total={false}
													display_origin={false}
													username={username}
													in_scores={true}
													stages={this.stages}
													validation_tags={this.props.validation_tags}	// only for OCR Ticket
													img_basedir={this.props.img_basedir}			// only for OCR Ticket
												/>
											) : (
												<div class="gui_participations_list is_builder">
													<div>{i18n("There are no results.")}</div>
												</div>
											)}
										</div>
									) : (
										<div class="tab_contents">
											<div class="gui_pos_rel" style={{minHeight:'20dvh'}}>
												<Spinner _class={{other:'is_transparent'}} force_bg={true}>Loading</Spinner>
											</div>
										</div>
									)}
								</div>
							)
						}} />

						<Route exact={true} path={'/stampcards'} render={(route) => {
							let stamp_cards = [];
							if(stamp_cards_stages.length > 0) {
								stamp_cards_stages.map((s)=> {
									const num_punches = parseInt(s.Stage.punch_num_punches);
									let participations_from_stage = [];
									this.stage_participations.summary.map((stage) => {
										if(stage.Participations == undefined) return false;
										if(stage.Participations.length == 0) return false;
										if(stage.Participations[0].User.stage != s.Stage.id) return false;

										participations_from_stage = stage.Participations.filter((u) => (u && u.User && u.User.stage == s.Stage.id));
									});

									participations_from_stage.reverse();
									const total_participations = participations_from_stage.length;

									if(participations_from_stage.length > 0) {
										const total_cards = Math.ceil(total_participations / num_punches);
										const stamps_in_last_card = total_participations % num_punches;
										for(let index = 0; index < total_cards; index++) {
											const is_completed = (stamps_in_last_card == 0 || index < total_cards - 1) ? true : false;

											const updated_index = (is_completed) ? (num_punches * (index + 1)) : (participations_from_stage.length);

											const pending_stamps = (!is_completed) ? (num_punches - stamps_in_last_card) : 0;

											stamp_cards.push({
												stage:s.Stage,
												completed:is_completed,
												pending:pending_stamps,
												current:num_punches - pending_stamps,
												updated:participations_from_stage[updated_index - 1].User.created,
											});
										}
									}
								});
							}

							stamp_cards.reverse();

							return (
								<div class="tabbed_registered_section">
									<NavigationTabs
										active={route.location.pathname}
										sections={tabs}
										display_type='tab'
									/>

									{(!this.state.loading) ? (
										<div class="tab_contents">
											<div class="gui_participations_list is_builder">
												<table class="single_user_participations" cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
													<thead>
														<tr>
															<th style={{width:'8%'}} />

															<th class="gui_text_align_start">{i18n("Stage")}</th>

															<th class="gui_text_align_start" style={{width:'18%'}}>{i18n("Completed")}</th>

															<th class="gui_text_align_start" style={{width:'25%'}}>{i18n("Last stamp")}</th>
															
															<th class="gui_text_align_end" style={{width:'8%'}} />
														</tr>
													</thead>

													<tbody>
														{stamp_cards.map((card, c) => {
															const counter = c + 1;
															const stage_title = getStageName(card.stage, i18n);

															return (
																<tr key={`card_${c}`}>
																	<td class="ranking_pos">#{(stamp_cards.length > 10 && counter < 10) ? `0${counter}` : counter}</td>

																	<td class="gui_text_align_start">
																		<div class="sided_contents">
																			<Tooltip position="top" icon='knk-punch-card'>Punch card</Tooltip>

																			<div class="title"><span class="gui_cutTextOnOverflow">{stage_title}</span></div>
																		</div>
																	</td>

																	<td class="gui_text_align_start">
																		{(card?.completed ?? false) ? (
																			<span class="ep-check-list-item greenIcon" />
																		) : (
																			<div class="sided_contents">
																				{`${card.current} / ${card.stage.punch_num_punches}`}
																			</div>
																		)}
																	</td>

																	<td class="gui_text_align_start">{`${EPDateFormat(card.updated, 'L, LT')} h`}</td>

																	<td class="gui_text_align_end">
																		<SquaredButton
																			icon='knk-visible'
																			aria-label="View card"
																			onClick={() => this.setState({ display_punch_card:card })}
																		/>
																	</td>
																</tr>
															)
														})}
													</tbody>
												</table>
											</div>

											{(this.state.display_punch_card !== false) && (
												<PunchCardStandalone
													stage={this.state.display_punch_card?.stage}
													is_completed={this.state.display_punch_card?.completed ?? false}
													force_num_stamps={this.state.display_punch_card?.current ?? 0}
													promotion={this.promotion.Promotion}
													is_builder={true}
													backButton={() => this.setState({ display_punch_card:false })}
													extra_contents={<p>{i18n("Last update")}: {EPDateFormat(this.state.display_punch_card.updated, 'L, LT')} h</p>}
													type='layer'
												/>
											)}
										</div>
									) : (
										<div class="tab_contents">
											<div class="gui_participations_list is_builder">
												<div class="gui_pos_rel" style={{minHeight:'20dvh'}}>
													<Spinner _class={{other:'is_transparent'}} force_bg={true}>Loading</Spinner>
												</div>
											</div>
										</div>
									)}
								</div>
							)
						}} />

						<Route exact={true} path={'/prizes'} render={(route) => {
							let has_codes = false;
							let has_redeemed_codes = false;

							const has_prize_fulfillment = owner?.promotion?.Promotion?.prize_fulfillment ?? false;

							this.prizes.map((prize) => {
								let prize_type = this.prize_types.find((obj) => { return obj.PrizeType.id == prize.Prize.prize_type });

								if(prize.PromoCode != undefined && prize.PromoCode.code != undefined && prize.PromoCode.code != "") has_codes = true;

								if(prize.Prize.prize_validated != undefined || (prize_type?.PrizeType?.redeemable ?? false)) has_redeemed_codes = true;
							});

							return (
								<div class="tabbed_registered_section">
									<NavigationTabs
										active={route.location.pathname}
										sections={tabs}
										display_type='tab'
									/>

									<div class="tab_contents">
										{(_size(this.prizes) > 0) ? (
											<div class="gui_participations_list is_builder">
												<table class="single_user_participations" cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
													<thead>
														<tr>
															<th style={{width:'8%'}} />

															<th class="gui_text_align_start">{i18n("Prize")}</th>


															{(has_codes) && (
																<th class="gui_text_align_start" style={{width:'18%'}}>{i18n("Code")}</th>
															)}

															{(has_redeemed_codes) && (
																<th class="gui_text_align_start" style={{width:'18%'}}>{i18n("Status")}</th>
															)}

															<th class="gui_text_align_start" style={{width:'22%'}}>{i18n("Date")}</th>

															{(has_prize_fulfillment) && (
																<th class="gui_text_align_start" style={{width:'18%'}}>{i18n("Claim form")}</th>
															)}

															<th class="gui_text_align_end" style={{width:'8%'}} />
														</tr>
													</thead>

													<tbody>
														{this.prizes.map((prize, p) => {
															const prize_type = this.prize_types.filter((obj) => { return obj.PrizeType.id == prize.Prize.prize_type })[0];
															
															let prize_download_url = false;
															if(prize_type?.PrizeType?.downloadable ?? false) {
																switch(prize_type.PrizeType.downloadable_origin) {
																	case 'coupon_maker':
																		prize_download_url = 'prize_download';
																		break;
																	case 'download':
																	case 'upload':
																		prize_download_url = 'prize_coupon';
																		break;
																}

																prize_download_url = window.public_url + prize_download_url + '/' + prize.Prize.id + '/' + prize.Prize.hash;
															}

															let prize_type_icon;
															let prize_type_label;
															switch(prize_type?.PrizeType?.assignation) {
																case '1':
																	prize_type_icon = 'knk-me';
																	prize_type_label = "By Manual Assignment";
																	break;
																case '2':
																	prize_type_icon = 'knk-ball-drum';
																	prize_type_label = "By Random Draw";
																	break;
																case '3':
																	prize_type_icon = 'knk-add-user';
																	prize_type_label = "On Participating";
																	break;
																case '4':
																	prize_type_icon = 'knk-timecounter';
																	prize_type_label = "By Instant Win";
																	break;
																case '5':
																	prize_type_icon = 'knk-roulette';
																	prize_type_label = "By probability";
																	break;
															}

															const tz = this.promotion.Promotion.timezone;
															const prize_created = moment.tz(prize.Prize.created,"Europe/Madrid").tz(tz);
															const code_validated = (prize.Prize.code_validated != undefined) ? prize.Prize.code_validated : false;
															const prize_validated = (prize.Prize.prize_validated != undefined) ? prize.Prize.prize_validated : false;

															const redeemed_at = (prize.Prize.redeemed_at != undefined) ? prize.Prize.redeemed_at : false;
															const has_expired = prize.Prize?.expired ?? false;
															const redeem_url = prize.Prize?.redeem_url ?? false;
															const counter = _size(this.prizes) - p;
															let prize_title = prize_type?.PrizeType?.title ?? "";
																prize_title += prize_type?.PrizeType.reference != undefined ? ' ('+prize_type?.PrizeType.reference+')' : '';
															if(!prize_type)return null; //Premi esborrat despres d'assignació
															const enable_remove_prize = !has_expired && (prize_type.PrizeType.assignation =='6' || prize_type.PrizeType.assignation == '1') ? true : false;
															const enable_release_prize = (has_redeemed_codes && !prize_validated && has_expired) ? true : false;

															const pclaim = prize.PromoClaim

															return (
																<tr key={'p' + p}>
																	<td class="ranking_pos">#{(_size(this.prizes) > 10 && counter < 10) ? "0" + counter : counter}</td>

																	<td class="gui_text_align_start">
																		<div class="sided_contents">
																			<Tooltip position="top" icon={prize_type_icon}>{prize_type_label}</Tooltip>

																			<div class="title"><span class="gui_cutTextOnOverflow">{prize_title}</span></div>
																		</div>
																	</td>

																	{(has_codes) && (
																		<td class="gui_text_align_start">{prize.PromoCode.code}</td>
																	)}

																	{(has_redeemed_codes) && (
																		<td class="gui_text_align_start gui_pos_rel">
																			<div class="sided_contents">
																				{(code_validated && false) && (
																					<Tooltip
																						position="top"
																						icon="knk-calendar"
																						autotranslate={false}
																					>{`${EPDateFormat(code_validated, 'L, LT')} h`}</Tooltip>
																				)}

																				{(prize_validated) ? (
																					<span>
																						<Tooltip
																							position="top"
																							icon="knk-information greenIcon"
																							autotranslate={false}
																						>{`${redeemed_at ? redeemed_at+': ' : ''}${EPDateFormat(prize_validated, 'L, LT')} h`}</Tooltip>

																						<span class="gui_cutTextOnOverflow greenColor" style={{ width:'calc(100% - 2em)'}}>
																							{i18n("***Redeemed")}
																						</span>
																					</span>
																				) : (
																					(has_expired) ? (
																						<span class="gui_cutTextOnOverflow redColor">{i18n("***Expired")}</span>
																					) : (
																						(redeem_url) && (
																							<ActionLink
																								_href={redeem_url}
																								_target="_blank"
																							>Redeem link</ActionLink>
																						)
																					)
																				)}
																			</div>
																		</td>
																	)}

																	<td class="gui_text_align_start">{`${EPDateFormat(prize_created, 'L, LT')} h`}</td>

																	{(has_prize_fulfillment) && (
																		<td class="gui_text_align_start gui_pos_rel">
																			<div class="sided_contents">
																				<StatusClaim 
																					user={this.register.User}
																					prize={prize}
																					prize_type={prize_type?.PrizeType ?? null}
																					promo_claim={pclaim}
																					promotion = {this.promotion.Promotion}
																					intl={this.props.intl}
																					detail_status={false}
																					detail_data={true}
																				/>
																			
																			</div>
																		</td>
																	)}

																	<td class="gui_text_align_end">
																		<ButtonCollection>
																		{(prize_download_url !== false) && (
																			<SquaredButton
																				_href={prize_download_url}
																				_target="_blank"
																				icon='knk-download'
																				aria-label="Download prize"
																			/>
																		)}
																		{(enable_remove_prize || enable_release_prize) && (
																			<DeleteButton
																				onClick={()=>this.deletePrize(prize.Prize.id)}
																				aria-label="Unredeem prize"
																				_position='left'
																				tooltip={enable_release_prize ? <Tooltip with_icon={false} position='top'>Release prize</Tooltip> : null}
																			/>
																		)}
																		
																		<SendClaimActions
																			user={this.register.User}
																			promotion={this.promotion.Promotion}
																			prize={prize.Prize}
																			promo_claim={pclaim}
																			intl={this.props.intl}
																		/>
																		</ButtonCollection>
																	</td>
																</tr>
															)
														})}
													</tbody>
												</table>
											</div>
										) : (
											<div class="gui_participations_list is_builder">
												<div>{i18n("There are no results.")}</div>
											</div>
										)}
									</div>
								</div>
							)
						}} />

						<Route exact={true} path={'/loyalty'} render={(route) => {
							if(!has_loyalty) {
								window.location.hash = `/`;
								return;
							}

							return (
								<VirtualCoinsResumee
									{...this.props?.loyalty ?? {}}
									navigation_props={{
										actual_section:route.location.pathname,
										sections:tabs,
									}}
									actual_tokens={this.state.total_loyalty_tokens}
									onManuallyUpdate={this.updateLoyaltyTokens.bind(this)}
									login_id={this.props.login_id}
									promotion={this.promotion.Promotion}
									intl={this.props.intl}
								/>
							)
						}} />

						<Route exact={true} path={'/other'} render={(route) => {
							let toc_url = false;
							if(this.promotion.Promotion.toc != undefined && this.promotion.Promotion.toc != "") {
								toc_url = window.public_url + 'promo_terms/' + this.promotion.Promotion.id;
							}  
							if(this.promotion.Promotion.external_toc_url != undefined && this.promotion.Promotion.external_toc_url != "") {
								toc_url = this.promotion.Promotion.external_toc_url;
							}

							let policy_url = false;
							if(this.promotion.Promotion.policy != undefined && this.promotion.Promotion.policy != "") {
								policy_url = window.public_url + 'policy/' + this.promotion.Promotion.id;
							} else if(this.promotion.Promotion.external_policy_url != undefined && this.promotion.Promotion.external_policy_url != "") {
								policy_url = this.promotion.Promotion.external_policy_url;
							}

							let cookies_url = false;
							let cookies_accepted = false;
							if(isNotEmpty(this.promotion.Promotion.config,'cookies_policy',["0"])){
								cookies_url = `${window.public_url}cookies/${this.promotion.Promotion.id}`;
								if(this.register.User.cookies_accepted != undefined) cookies_accepted = this.register.User.cookies_accepted;
							}

							let icon_browser = this.register.User.browser == 'in-app' ? 'knk-diagram' : `knk-${this.register.User.browser}`;
							return (
								<div class="tabbed_registered_section">
									<NavigationTabs
										active={route.location.pathname}
										sections={tabs}
										display_type='tab'
									/>

									<div class="tab_contents">
											<div class="gui_participations_list is_builder">
										<div class="registered_information_contents">
											<ul>
												<li class="knk-ip">
													<strong>{i18n("IP Address")}</strong>
													<span>{(isNotEmpty(this.register.User, 'ip')) ? this.register.User.ip : '-'}</span>
												</li>

												{(this.register.User.device != undefined && this.register.User.device != "") && (
													<li class={`knk-${this.register.User.device}`}>
														<strong>{i18n("Device")}</strong>
														<span>{this.register.User.device_label}</span>
													</li>
												)}

												{(this.register.User.browser != undefined && this.register.User.browser != "") && (
													<li class={`${icon_browser}`}>
														<strong>{i18n("Browser")}</strong>
														<span>{this.register.User.browser_label} <Tooltip position="top">{this.register.User.u_agent}</Tooltip></span>
													</li>
												)}

												{(this.register.User.campaign_info != undefined && _size(this.register.User.campaign_info) > 0) && (
													<li class="knk-promote">
														<strong>{i18n("source", 'ucfirst')}</strong>
														<span class="sublisted_items">
															{this.register.User.campaign_info.map((source, s) => {
																return (
																	<span key={'source_' + s}>{source.value}</span>
																)
															})}
														</span>
													</li>
												)}

												{(toc_url !== false) && (
													<li class="knk-toc">
														<strong>{i18n("Terms and conditions")}</strong>
														<span><span class="section_status ep-circle greenIcon" /> {i18n("Accepted")} [<ActionLink _href={toc_url} _target="_blank" autotranslate={false}>{i18n("View", 'lowercase')}</ActionLink>]</span>
													</li>
												)}

												{(policy_url !== false) && (
													<li class="knk-zipped">
														<strong>{i18n("Privacy policy")}</strong>
														<span><span class="section_status ep-circle greenIcon" /> {i18n("Accepted")} [<ActionLink _href={policy_url} _target="_blank" autotranslate={false}>{i18n("View", 'lowercase')}</ActionLink>]</span>
													</li>
												)}

												{(cookies_url !== false) && (
													<li class="knk-cookie">
														<strong>{i18n("Cookie policy")}</strong>
														<span><span class={'section_status ep-circle ' + ((cookies_accepted) ? 'greenIcon' : 'redIcon')} /> {i18n((cookies_accepted) ? "Accepted" : "Rejected")} [<ActionLink _href={cookies_url} _target="_blank" autotranslate={false}>{i18n("View", 'lowercase')}</ActionLink>]</span>
													</li>
												)}
											</ul>

											<ul>
												{(has_full_name && isNotEmpty(this.register.User, 'first_name') && isNotEmpty(this.register.User, 'last_name')) && (
													<li class="knk-user">
														<strong>{i18n("Full name")}</strong>
														<span>{this.register.User.first_name} {this.register.User.last_name.toUpperCase()}</span>
													</li>
												)}

												{(this.register.User.phone) && (
													<li class="knk-phone">
														<strong>{i18n("Phone")}</strong>
														<span>{this.register.User.phone}</span>
													</li>
												)}

												{(this.register.User.city) && (
													<li class="knk-city">
														<strong>{i18n("City")}</strong>
														<span>{this.register.User.city}</span>
													</li>
												)}

												{(this.register.User.country) && (
													<li class="knk-geographic-area">
														<strong>{i18n("Country")}</strong>
														<span>{this.register.User.country}</span>
													</li>
												)}

												{(this.register.User.sex) && (
													<li class="knk-gender">
														<strong>{i18n("Gender")}</strong>
														<span>{i18n(this.register.User.sex)}</span>
													</li>
												)}

												{(this.register.User.birthday) && (
													<li class="knk-calendar">
														<strong>{i18n("Birthday")}</strong>
														<span>{EPDateFormat(this.register.User.birthday, 'L')} ({EPDateDiff(null, this.register.User.birthday, 'years')} {i18n("years")})</span>
													</li>
												)}

												{_size(this.promotion.CustomField) > 0 && this.promotion.CustomField.map((field, cf) => {
													if(field.stage != '0') return null;

													const answered_value = (this.register.CustomValue != undefined) ? this.register.CustomValue.filter((obj) => { return obj.custom_field_id == field.id})[0] : false;

													let cf_type;
													let cf_icon;

													switch(field.type) {
														case '1':
															cf_type = 'text';
															cf_icon = 'knk-text';
															break;

														case '2':
															cf_type = 'select';
															cf_icon = 'knk-options-list';
															break;

														case '3':
															cf_type = 'checkbox';
															cf_icon = 'knk-ok';
															break;

														case '4':
															cf_type = 'radio';
															cf_icon = 'knk-radiobutton-on';
															break;

														case '5':
															cf_type = 'autocomplete';
															cf_icon = 'knk-prediction';
															break;

														case '6':
															cf_type = 'data';
															cf_icon = 'knk-calendar';
															break;

														case '7':
															cf_type = 'file';
															cf_icon = 'knk-attachment';
															if(answered_value != undefined && !answered_value.value) return null;
															break;

														case '8':
															cf_type = 'hidden';
															cf_icon = 'knk-invisible';
															break;

														case '9':
															cf_type = 'passthrough';
															cf_icon = 'knk-footer';
															break;

														case '10':
															cf_type = 'country';
															cf_icon = 'knk-geographic-area';
															break;

														case '11':
															cf_type = 'segment';
															cf_icon = 'knk-options-list';
															break;

														case '12':
															cf_type = 'card';
															cf_icon = 'knk-id-card';
															break;

														case '13':
															cf_type = 'signature';
															cf_icon = 'knk-signature';
															break;

														case '14':
															cf_type = 'multi_checkbox';
															cf_icon = 'knk-multichoice';
															break;
													}

													let cf_title = field?.title ?? `[ ${i18n("No title")} ]`;
													if(field.short_title != undefined && field.short_title != "") cf_title = field.short_title;

													if(answered_value == undefined) {
														return (
															<li key={`cf_${cf}`} class={cf_icon}>
																<strong>{cf_title}</strong>
																<span>-- {i18n("Not answered")} --</span>
															</li>
														)
													}

													const answer = (cf_type != 'checkbox') ? answered_value.value : i18n((answered_value.value == '1') ? "Checked" : "Unchecked");

													let li_props = { key:`cf_${cf}`, class:cf_icon }

													if(cf_type == 'checkbox') {
														return (
															<li {...li_props}>
																<strong>{cf_title}</strong>

																<span><span class={'section_status ep-circle ' + ((answered_value.value == '1') ? 'greenIcon' : 'redIcon')} /> {i18n((answered_value.value == '1') ? "Checked" : "Unchecked")}</span>
															</li>
														)
													}

													if(cf_type == 'signature') {
														return (
															<li {...li_props}>
																<div class="file_thumbnail">
																	<strong>{cf_title}</strong>

																	<img src={answer} height={50} alt="" />

																	<ButtonCollection>
																		<SquaredButton
																			icon='knk-download'
																			_target='_blank'
																			_href={answer}
																			aria-label="Download image"
																		/>
																	</ButtonCollection>
																</div>
															</li>
														)
													}

													if(cf_type == 'file') {
														return (
															<li {...li_props}>
																<strong>{cf_title}</strong>

																<span>[<ActionLink _href={answer} _target="_blank" autotranslate={false}>{i18n("View", 'lowercase')}</ActionLink>]</span>
															</li>
														)
													}

													if(cf_type == 'select' || cf_type == 'radio') {
														const is_keypairs = parseInt(field?.config?.keyvalue ?? '0');
														if(is_keypairs == 1) {
															const answered_value = field.options.find((o) => (o.k == answer));
															if(answered_value != undefined) {
																return (
																	<li {...li_props}>
																		<strong>{cf_title}</strong>

																		<span>{answered_value.v} ({answered_value.k})</span>
																	</li>
																)
															}
														}
													}

													if(cf_type == 'multi_checkbox') {
														let values = JSON.parse(answer).map((key) => {
															const answered_value = field.options.find((o) => (o.k == key));
															if(answered_value == undefined) return null;
															return answered_value;
														});

														values = values.filter((n) => n);
														
														if(values != undefined) {
															return (
																<li {...li_props}>
																	<strong>{cf_title}</strong>

																	<span>
																		<ul class="bulleted_list" style={{ listStyleType:'disc' }}>
																			{values.map((option, o) => {
																				return (
																					<li key={`option_${o}`}>{option.v}</li>
																				)
																			})}
																		</ul>
																	</span>
																</li>
															)
														}
													}

													if(cf_type == 'segment') {
														const answered_value = field.config?.segments.find((o) => (o.segment_id == answer));
														if(answered_value != undefined) {
															return (
																<li {...li_props}>
																	<strong>{cf_title}</strong>

																	<span>{answered_value.label != undefined ? `${answered_value.label} (${answered_value.name})` : answered_value.name}</span>
																</li>
															)
														}
													}

													return (
														<li {...li_props}>
															<strong>{cf_title}</strong>

															<span>{answer}</span>
														</li>
													)
												})}
											</ul>
										</div>
									</div>
								</div>
								</div>
							)
						}} />
					</div>
				</Router>
			</div>
		);
	}
}

export default injectIntl(SingleRegisteredEntry);